import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

function useQueryStrings() {
    const { search } = useLocation()
    const strings = useMemo(() => new URLSearchParams(search), [search])

    return strings
}

export default useQueryStrings
